import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZPaqueteriaC: IAbstractModule = {
  type: IModuleType.paqueteriaZ,
  name: 'Z Paqueteria C (21-30)',
  hasScreen: false,
  columns: [
    [
      {
        name: "1",
        connector: "21",
        cell_size_id: 4,
        accessible: false,
      },
      {
        name: "2",
        connector: "22",
        cell_size_id: 2,
        accessible: false,
      },
      {
        name: "3",
        connector: "23",
        cell_size_id: 2,
        accessible: false,
      },
      {
        name: "4",
        connector: "24",
        cell_size_id: 3,
        accessible: false,
      },
      {
        name: "5",
        connector: "25",
        cell_size_id: 3,
        accessible: false,
      },
      {
        name: "6",
        connector: "26",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "7",
        connector: "27",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "8",
        connector: "28",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "9",
        connector: "29",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "10",
        connector: "30",
        cell_size_id: 4,
        accessible: false,
      },
    ],
  ]
};
